<div class="grid-container">
  <div class="grid-x">
    <div [formGroup]="controlFormGroup" class="grid-x align-middle input">
      <label data-cy="toggle-switch" class="switch">
        <input type="checkbox" [formControlName]="controlName" />
        <span class="slider round"></span>
      </label>
    </div>
    <div *ngIf="hasLabel" class="padding-1 grid-x align-middle">
      <label
        [ngClass]="controlFormGroup.controls[controlName].value ? 'slider-label-enable' : 'slider-label-disable'"
        >{{ controlFormGroup.controls[controlName].value ? 'On' : 'Off' }}</label
      >
    </div>
  </div>
</div>
